import { connect } from 'react-redux';

import { openDrawer } from 'actions/drawer';
import { DRAWER_EDIT_GROUP } from 'types/drawer';
import { getCurrentUserIdSelector } from 'selectors/user';

import MulticastFeeds from 'components/LeftMenu/MulticastFeeds';
import  { selectors } from '@amplement/backend-connector';


const mapStateToProps = (state) => {
    const _currentUser = getCurrentUserIdSelector(state);
    const _feeds = selectors.feeds.getFeedsAcceptedMulticastIds(state);
    const isLoading = !selectors.feeds.getFeedsLoaded(state);
    const error = selectors.feeds.getFeedsError(state);

    return {
        _feeds,
        isDrawerOpen: state.drawer[DRAWER_EDIT_GROUP].isVisible,
        isLoading,
        _currentUser,
        error
    };
};

const mapDispatchToProps = dispatch => ({
    openCreationDrawer: () => dispatch(openDrawer(DRAWER_EDIT_GROUP), { _feed: undefined }),
    openEditionDrawer: _feed => dispatch(openDrawer(DRAWER_EDIT_GROUP, { _feed }))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MulticastFeeds);
